// conductor-mcp · conductor b6837825 (main) · origin: dev-mcp · domain: moms · body d510718406a2
// generated by pbo-conductor — 출고취소(비제스트) (gi40)
// conductor-build: b683782 2026-11-03T04:23:13.900Z · pbo-core 0.8.7
// dev 위치: pages/outbound/bizestCancelResult
// 데이터 seam: useGetBizestCancelResults — TODO(dev): 목데이터를 이 훅으로 교체
//
// 그룹 규격 — 이 화면이 쓰는 공통 조합의 계약(컨덕터 소유).
//   이 값을 벗어나면 컨덕터 데모와 어긋납니다. 규격을 바꾸려면 컨덕터에서 바꾸세요.
//   ⚠️ 그룹은 화면마다 사본으로 나갑니다 — 여기서 고쳐도 다른 화면은 바뀌지 않습니다.
//   titleRow #0d760c
//     · title(제목) — 자유 입력
//     · backRoute(뒤로가기 라우트) — 자유 입력
//     · notice(제목 옆 안내 문구) — 자유 입력
//     · stickyTop(스티키 멈춤 위치(px)) 제한 없음 [기본 12]
//     · buttonSize(타이틀 버튼 크기) = S | M | L [기본 L]
//     · 제목 옆 컨트롤과 우측 액션은 자리를 섞지 않는다 — 컨텍스트(센터·뷰)는 제목 옆, 행위는 우측 끝
//   filterCard #e70a16
//     · platform(배치 규약(desktop 라벨 위·3~4열 / moss 라벨 왼쪽·항상 3열)) = desktop | moss [기본 desktop]
//     · searchText(조회 버튼 문구) — 자유 입력
//     · resetText(초기화 버튼 문구) — 자유 입력
//     · defaultCollapsed(진입 시 접힘) = 켬 | 끔 [기본 false]
//     · summaryMessage(요약 카드 아래 안내 문구(summary 슬롯 있을 때)) — 자유 입력
//     · cols(한 줄 항목 수(moss)) 3~3개
//     · colGap(항목 가로 간격(moss)) 제한 없음
//     · rowGap(줄 세로 간격(moss)) 제한 없음
//     · labelWidth(라벨 칸 고정폭(moss)) 제한 없음
//     · labelGap(라벨-값 간격(moss)) 제한 없음
//     · itemMaxWidth(필터 항목 최대 폭) ≤ 420px [기본 420px]
//     · itemsPerRow(한 줄 항목 수) 3~4개 [기본 4개]
//     · collapsedShows(접었을 때 노출) = 값이 있는 항목만 | 전부 [기본 값이 있는 항목만]
//     · twoColBreakpoint(2단 필드 칩 접힘 폭) 제한 없음 [기본 320px]
//     · valueMinWidth(값 컨트롤 최소 폭) 제한 없음 [기본 240px]
//     · typeMinWidth(유형 셀렉트 최소 폭) 제한 없음 [기본 88px]
//     · typeMaxWidth(유형 셀렉트 최대 폭) 제한 없음 [기본 120px]
//     · 필터 항목 width는 max 420px 해상도에 따라 조절
//     · 한 줄에 필터 항목 3개부터 최대 4개까지 노출.
//     · 필터 접기 시, 값이 있는 필터만 노출
//     · 필터 접기 시, 값이 전부 없는 경우 문구 노출.
//   tableGroup #7b6f57
//     · pagerVariant(페이저 표기) = paged | range [기본 paged]
//     · pager(페이저 노출) = 켬 | 끔 [기본 true]
//     · listSearch(목록 검색 노출) = 켬 | 끔 [기본 true]
//     · pagerSizeChanger('몇개씩' 노출) = auto | hide [기본 auto]
//     · rightFirst(화면 우측 요소를 표준 앞에) = 켬 | 끔 [기본 false]
//     · leadColumns(선두 컬럼) = 체크박스 → No | No | 없음 [기본 체크박스 → No]
//     · checkboxWidth(체크박스 폭) 제한 없음 [기본 48px]
//     · noWidth(No 폭) 제한 없음 [기본 48px]
//     · 값·말줄임 짤림 금지 — 컬럼 폭은 콘텐츠 맞춤
//     · 엑셀 다운로드는 exportColumns(한글 헤더) 지정
//
import { core } from '@musinsa/pbo-core'
import { pboLogisticsTheme } from '@musinsa/pbo-core/theme'
import '@musinsa/pbo-core/tokens.css'
import '@musinsa/pbo-core/styles.css'
import '@musinsa/pbo-core/fonts.css'
import './screenShell.css'
import { wiring } from './wiring'
import { type ComponentProps, type FC, type ReactNode, useEffect, useMemo, useRef, useState } from 'react'
import { DownOutlined, PlusOutlined, UpOutlined } from '@ant-design/icons'
import dayjs, { type Dayjs } from 'dayjs'
import { Icon as DsIcon } from '@musinsa/pbo-assets'
import { usePageHeaderSticky } from './pageHeaderSticky'

/** 배선 계약(문서 50) — wiring.ts(개발자 소유)가 이 타입을 채운다. 이름은 노드 id·상수명에서 기계적으로 나온다.
 *  화면(이 파일)은 재핸드오프 때 통째로 덮어쓴다 — 계약이 바뀌면 dev tsc 가 wiring.ts 의 그 자리를 가리킨다. */
export type Row = Record<string, unknown>
/** 표 슬롯 인자 — filters = 같은 화면 조회영역 값(키 = filterKey/노드 id) · pager = 액션바 페이저(page 1부터, size). 없는 화면은 undefined.
 *  모달 안 후보 표는 filters = 모달 [조회]가 적용한 조건(__applied: true 가 있으면 눌렀음, {} 이면 아직) · target = 그 모달을 연 셀(행·칸). */
export type RowsQuery = { filters?: Record<string, unknown>; pager?: { page: number; size: number }; target?: CellTarget; meta?: Record<string, unknown> } // meta = 모달 열림 페이로드(국가 등 — 한 모달을 여러 행이 공유할 때)
/** 액션 슬롯 인자 — selected = 같은 core.TableSelectionScope 안 표의 선택 행(체크박스). 선택 표가 없는 화면은 빈 배열. */
export type ActionCtx = { selected: Row[]; visible?: Row[]; form?: FormState; picked?: Row[]; target?: CellTarget; files?: MediaFile[]; value?: string; meta?: Record<string, unknown> } // selected = 체크 선택 행 · visible = 목록 검색 뒤 화면에 보이는 행(표가 여럿이면 마지막 표, 검색칸 없는 화면은 없음) · form = 확인을 누른 모달의 폼 값(폼 스토어가 있는 모달만) · value = Enter 로 확정한 입력 값(<입력>_enter 슬롯만)
/** 폼 버스 상태(모달·카드의 입력 값). 조건(hideWhen 등)은 wiring.form.<store> 가 덮어쓴 유효 상태를 본다. */
export type FormState = Record<string, unknown>
/** 선택지(옵션) — value 는 API/코드 값, label 은 표시 문구. 조회영역·모달 셀렉트/라디오는 숫자 value 도 쓴다. */
export type Option = { value: string | number; label: string }
/** 편집 셀 셀렉트의 선택지 — DS 셀 계약(variantProps.options)이 value 를 문자열로만 받는다. */
export type CellOption = { value: string; label: string }
/** 셀이 연 모달의 대상(2026-09-30) — rowKey = 그 행의 key(배열 인덱스 또는 배선이 실은 key) · dataIndex = 연 칸 · row = 그 행 · value = 미디어 셀 값(개수). 헬퍼·미디어 모달 슬롯의 ctx.target. */
export type CellTarget = { rowKey: string; dataIndex: string; row: Row; value?: unknown }
/** 미디어 모달 파일(DS core.MediaManager 계약 — 이름·썸네일뿐이라 서버 파일은 배선이 이름으로 잇는다). 헬퍼·미디어 모달 슬롯의 ctx.files. */
export type MediaFile = { name: string; thumb?: string }
/** 표 컬럼 배치(2026-10-21) — DS core.Table 의 제어형 prop 그대로. 컬럼 id = dataIndex(재핸드오프로 dataIndex 가 바뀌면 그 컬럼 저장값은 무시된다).
 *  순서·너비는 조절한 것만 와도 된다. 초기화는 []/{} (undefined 로 바꾸면 비제어로 돌아가 직전 내부 상태가 남는다). */
export type ColumnLayout = Pick<core.CoreTableProps, 'columnOrder' | 'onColumnOrderChange' | 'columnWidths' | 'onColumnWidthsChange' | 'pinnedColumns' | 'onPinnedColumnsChange' | 'hiddenColumns' | 'onHiddenColumnsChange'>
export type Wiring = {
  /** 표 데이터 — 인자는 데모 목데이터(자리 표시)와 조회 조건·페이저. 컴포넌트 본문 첫머리에서 항상 같은 순서로 불리므로 안에서 조회 훅을 써도 된다.
   *  배열을 돌려주면 클라이언트 페이징(데모와 같음), { rows, total } 을 돌려주면 서버 페이징(표는 그대로 그리고 카운트·페이저는 total). */
  rows: { ROWS: (demo: Row[], q: RowsQuery) => Row[] | { rows: Row[]; total?: number; loading?: boolean } }
  /** 동작 — 조회(search)·버튼·확인창·모달 확인·편집 셀·행 버튼. 실패는 throw(확인창·모달이 열린 채 남는다). 성공 토스트·닫기는 생성본이 한다. */
  actions: { search: (filters: Record<string, unknown>) => void | false | Promise<void | false>; bcDownloadModal_ok: (ctx: ActionCtx) => void | string | false | Promise<void | string | false> }
  /** 요청 진행 중 여부(React 훅) — true 면 선택 게이트 버튼(확정·삭제·저장 등)이 잠긴다. 선택 게이트 버튼이 매 렌더 부르므로 안에서 훅을 써도 된다(예: react-query useIsMutating() > 0). 없으면 잠그지 않는다. */
  useBusy?: () => boolean
  /** 액션 슬롯 실패 기록(슬롯 이름 · 원인) — 모니터링·토스트 등. 없으면 생성본이 다시 던져 미처리 거부로 올린다(콘솔엔 브라우저가 찍는다). */
  onActionError?: (slot: string, error: unknown) => void
  /** [초기화] 전 확인 — false(또는 false 로 풀리는 Promise)면 초기화하지 않는다(미저장 행 보호 확인창). 없으면 바로 초기화. */
  canReset?: () => boolean | Promise<boolean>
  /** 선택 비우기 신호 — 배선이 표를 새로 깔면(재조회 뒤) 이 값을 바꾼다(예: 조회 응답 식별자). 바뀔 때마다 체크 선택이 비워진다. */
  selResetToken?: unknown
  /** 조회 칸 필수 덮어쓰기(키 = 조회 조건 키) — 권한·서버 설정으로 필수가 풀리는 칸. 없으면 데모대로 필수. */
  filterRequired?: { "bcShipper:filterFieldDef"?: boolean; "bcClsDate:filterFieldDef"?: boolean }
  /** 표 컬럼 가공(키 = 표 노드 id) — 플래그 열 추가·제목 치환 등 정의 자체를 바꾼다. 배치(순서·너비·고정·숨김)는 columnLayout. 메모돼 표 상태가 유지된다. */
  columns?: { bcTable?: (columns: core.CoreColumnType[]) => core.CoreColumnType[] }
  /** 표 그룹 문구(키 = 표 그룹 노드 id) — 카운트 라벨("전체"→"조회" 등)·빈 표 문구. 없으면 데모 문구. */
  tableText?: { tableGroup?: { totalLabel?: string; emptyText?: string } }
  /** 표 위 안내 자리(키 = 표 그룹 노드 id) — 조회 결과 안내(건수 초과·경고)를 ReactNode 로. 없으면 비어 있다. */
  feedback?: { tableGroup?: ReactNode }
  /** 표 체크 선택이 바뀔 때 — 상세 표가 선택을 따라가는 화면(마스터-디테일)에서 배선이 그 키로 상세를 조회한다.
   *  선택이 있는 스코프만 알린다(위아래 표에서 빈 스코프가 덮지 않게). 액션 슬롯의 ctx.selected 와 같은 값이다.
   *  scope = **그 선택이 어느 표 그룹의 것인지**(그룹 노드 id). 위아래 표가 있는 화면은 이것으로 갈라 둔다 —
   *  선택을 **푼** 신호는 rows 가 빈 배열이라 행만 보고는 어느 표인지 알 수 없다(2026-09-21 est01). */
  onSelect?: (rows: Row[], scope: string) => void
  /** 조회영역 칸 잠금 — 키 = 조회 조건 키(filterKey). true 면 그 칸을 비활성으로 그린다(예: 화주 고정 계정의 화주유형/화주명).
   *  값은 잠그지 않는다 — 잠긴 칸의 값은 filterDefaults 로 넣고, 조회 슬롯에서도 서버로 나가는 값을 직접 고정할 것.
   *  **카드 키**(조회 카드 id)로 주면 함수다 — 현재 조회영역 값을 받아 `{ 필드: 잠금 }` 을 돌려준다(다른 칸 값·FF 에 따라 잠글 때). 칸별 boolean 이 있으면 그것이 먼저다. */
  filterDisabled?: { ORD_NO?: boolean; ORD_OPT_NO?: boolean; bcFilterCard?: (filters: Record<string, unknown>) => Record<string, boolean> }
  /** 페이지를 옮기기 **전** 물어본다 — false 를 주면 옮기지 않는다(미저장 편집 보호 등, 옛 손코드의 window.confirm 자리).
   *  확인 모달(core.Modal.confirm)로 물을 땐 Promise<boolean> 을 돌려준다 — 답이 true 로 오면 그때 옮긴다(false·거부면 그대로).
   *  onState 는 **이미 바뀐 뒤** 통지라 되돌릴 수 없다 — 막아야 하는 것은 여기서 막는다. 없으면 그냥 옮긴다. */
  canChangePage?: (next: { pager: string; page: number; size: number }) => boolean | Promise<boolean>
  /** [초기화] 직후 알림 — 생성본은 조회영역 입력값만 기본값으로 되돌린다. 목록(조회 결과)·페이지·표 선택·목록 검색어는 그대로다.
   *  화면 밖에 저장한 입력 조건(URL/세션 등)을 기본값으로 맞출 때만 쓴다. **조회 결과를 비우거나 재조회하지 않는다** — 목록은 [조회]로만 바뀐다(PD 결정 2026-10-21). 없으면 화면 값만. */
  onReset?: () => void
  /** 화면 상태(페이저·목록 검색어·상태 탭) 진입 초기값 — 동기 함수 아님, 값(예: URL 복원). 없으면 데모 기본값(1페이지·빈 검색어·기본 탭). */
  stateInitial?: { pager?: { "pager"?: { page?: number; size?: number } }; listq?: { "table.q"?: string } }
  /** 화면 상태가 바뀔 때(페이지 이동·검색어 확정·상태 탭 전환·조회 초기화) — 배선이 URL/세션에 싣는다(옛 손코드 page/keyword/tab persist). 상태 탭 값 = 탭 key('all' = 전체). */
  onState?: (s: { pager: { "pager": { page: number; size: number } }; listq: { "table.q": string } }) => void
  /** 모달 열기 전 가드 — 버튼 클릭 때 선택 행(ctx.selected)으로 부른다. false 를 돌려주면 열지 않는다(왜 못 여는지는 배선이 토스트로). 없으면 그냥 연다. */
  opens?: { bcExcelButton?: (ctx: ActionCtx) => boolean }
  /** 모달·드로어가 열리고 닫힐 때 — 열려 있는 동안에만 후보를 조회하는 게이트 자리(옛 손코드 `isXxxHelperOpen`).
   *  서치헬퍼 후보 API 는 무페이징 distinct 라 모달 밖에서 부르면 진입하자마자·타이핑마다 수십 MB 를 받는다
   *  (moms-fe #792 리뷰). 배선이 이 신호로 옛 게이트를 그대로 복원한다. 키 = 모달 노드 id. */
  onModal?: (open: { "bcDownloadModal": boolean }) => void
  /** 옵션 — 조회영역 셀렉트·라디오·편집 셀 셀렉트의 선택지. 인자는 데모 옵션(자리 표시). 컴포넌트 첫머리에서 항상 같은 순서로 불리므로 안에서 조회 훅(콤보 API 등)을 써도 된다.
   *  데모는 value=label 목데이터라, API 로 바꾸면(예: 화주 = 코드) 조회 조건·저장 값도 그 value 로 나간다 — 조회 기본값은 filterDefaults 로 같이 맞출 것.
   *  조회영역 옵션은 두 번째 인자로 **현재 조회영역 값**을 받는다(예: 화주유형 → 그 유형의 화주명만). */
  options?: { BCSHIPPER_OPTIONS?: (demo: Option[], filters?: Record<string, unknown>) => Option[]; BCOIFAPIFLAG_OPTIONS?: (demo: Option[], filters?: Record<string, unknown>) => Option[]; BCRSNCODE_OPTIONS?: (demo: Option[], filters?: Record<string, unknown>) => Option[]; REASONRADIO_OPTIONS?: (demo: Option[], filters?: Record<string, unknown>) => Option[] }
  /** 조회 조건 기본값 — 데모 기본값(예: 화주명 "무신사스탠다드")을 실값(예: 로그인 사용자 화주 코드)으로 덮어쓴다. **동기 함수**(훅 금지 — useMemo 안에서 한 번 계산). */
  filterDefaults?: { bcFilterCard?: (demo: Record<string, unknown>) => Record<string, unknown> }
  /** 진입 초기값 — 기본값 위에 URL/세션 복원값을 얹는다(동기 함수). [초기화] 는 여기 값이 아니라 filterDefaults 로 돌아간다. */
  filterInitial?: { bcFilterCard?: (defaults: Record<string, unknown>) => Record<string, unknown> }
  /** 늦게 오는 기본값 — 옵션(화주 목록 등)이 도착한 뒤 **비어 있는** 조회 조건을 채운다(예: 세션 화주가 없으면 첫 화주). 인자 = 현재 조회영역 값 · 조회영역 옵션들(슬롯명 = 키). 옵션 배열이 바뀔 때마다·[초기화] 뒤에 다시 부른다. 값이 있는 키는 덮지 않는다. 동기 함수. */
  filterFallback?: { bcFilterCard?: (current: Record<string, unknown>, options: Record<string, Option[]>) => Record<string, unknown> | void }
  /** 표 컬럼 배치(2026-10-21, LOGISPRD-15649) — 사용자가 바꾼 순서·너비·고정·숨김을 배선이 저장·복원한다(예: 사용자·화주별 서버 저장).
   *  키 = 표 노드 id(재핸드오프로 표가 늘어도 밀리지 않는다). 함수 — 매 렌더 같은 자리에서 불리므로 안에서 저장 훅을 써도 된다.
   *  인자 columns = 그 표에 넘기는 컬럼 정의(정의 순서·기본 fixed) — 콜백은 바뀐 컬럼만 주므로 전체 상태 저장·고정 해제 복원에 쓴다.
   *  표에 따라 렌더마다 새 배열이다(본문 상수) — effect·memo 의존성에는 배열 대신 내용(dataIndex·fixed 목록)을 쓴다.
   *  없거나 그 표 키가 없으면 종전대로 표 내부 상태(저장 안 함). */
  columnLayout?: { "bcTable"?: (columns: core.CoreColumnType[]) => ColumnLayout }
  /** 폼 버스 파생 필드 — 데모에서 스코프(화면 배선)가 채우던 값(예: 지난 날짜면 locked=true)을 입력 값(state)에서 계산해 덮어쓴다. 없으면 입력 값 그대로. */
  form?: { bcDownloadModal?: (state: FormState) => FormState }
}
/** 뷰가 받는 배선 — 아직 안 채운 슬롯이 있어도 된다(`<View wiring={{}} />` 도 뜬다). 다 채운 모습은 `Wiring`. */
export type WiringInput = Omit<Partial<Wiring>, 'rows' | 'actions'> & { rows?: Partial<Wiring['rows']>; actions?: Partial<Wiring['actions']> }

const renderPboEmpty = () => <core.Empty image={core.Empty.PRESENTED_IMAGE_SIMPLE} description="데이터 없음" />

const BCSHIPPER_OPTIONS_DEMO: Option[] = [{"value":"MUSINSA","label":"MUSINSA"},{"value":"NIKE","label":"NIKE"},{"value":"NIKESAMPLE","label":"NIKESAMPLE"}]
const BCOIFAPIFLAG_OPTIONS_DEMO: Option[] = [{"value":"Y","label":"Y"},{"value":"N","label":"N"}]
const BCRSNCODE_OPTIONS_DEMO: Option[] = [{"value":"000","label":"000 취소완료"},{"value":"001","label":"001 출고진행중"},{"value":"002","label":"002 출고완료"},{"value":"003","label":"003 주문없음"},{"value":"004","label":"004 취소처리중"}]
// 액션 실패 기록 — 슬롯(wiring.ts)이 사용자 안내를 맡고, 생성본은 실패를 버리지 않고 원인과 함께 남긴다.
// 액션 실패 — 사용자 안내는 슬롯(wiring.ts)이 맡는다. 기록 슬롯(wiring.onActionError)이 있으면 거기로 넘기고, 없으면 다시 던져 미처리 거부로 올린다(원인을 버리지 않는다 · console 은 쓰지 않는다: dev no-console).
const reportActionError = (slot: string) => (e: unknown): void => { if (wiring.onActionError) { wiring.onActionError(slot, e); return } throw e }
// 조회 조건 기본값(데모) — 옵션을 API 로 바꾸면(예: 화주 = 코드) wiring.filterDefaults.bcFilterCard 가 같은 키를 그 value 로 덮어쓴다(예: 로그인 사용자 화주 코드).
const flBcFilterCardDefaults_DEMO: Record<string, unknown> = {}
const COLUMNS: core.CoreColumnType[] = [{"title":"취소요청일자","dataIndex":"clsDate","width":120},{"title":"주문번호","dataIndex":"orderNumber","width":160},{"title":"주문일련번호","dataIndex":"orderOptionNumber","width":140},{"title":"내부처리여부","dataIndex":"internalProcessed","width":110,"align":"center","variant":"tag","variantProps":{"tagColors":{"Y":"success","N":"default"}}},{"title":"전송처리결과","dataIndex":"transmitResult","width":110,"align":"center","variant":"tag","variantProps":{"tagColors":{"Y":"success","N":"default"}}},{"title":"사유코드","dataIndex":"reasonCode","width":100},{"title":"비고","dataIndex":"remark","width":240},{"title":"인입시간","dataIndex":"insertedAt","width":160}]
const ROWS_DEMO: Record<string, unknown>[] = [{"rowKey":"MUSINSA|ORD-DUMMY-0001|OPT-DUMMY-01","shipperCode":"MUSINSA","clsDate":"20260101","orderNumber":"ORD-DUMMY-0001","orderOptionNumber":"OPT-DUMMY-01","internalProcessed":"Y","transmitResult":"Y","reasonCode":"000","remark":"","insertedAt":"20260101093000"},{"rowKey":"MUSINSA|ORD-DUMMY-0002|OPT-DUMMY-02","shipperCode":"MUSINSA","clsDate":"20260101","orderNumber":"ORD-DUMMY-0002","orderOptionNumber":"OPT-DUMMY-02","internalProcessed":"Y","transmitResult":"N","reasonCode":"001","remark":"주문 상태 업데이트 API 실패.","insertedAt":"20260101101500"},{"rowKey":"MUSINSA|ORD-DUMMY-0003|OPT-DUMMY-03","shipperCode":"MUSINSA","clsDate":"20260101","orderNumber":"ORD-DUMMY-0003","orderOptionNumber":"OPT-DUMMY-03","internalProcessed":"N","transmitResult":"N","reasonCode":"","remark":"","insertedAt":"20260101113000"},{"rowKey":"MUSINSA|ORD-DUMMY-0004|OPT-DUMMY-04","shipperCode":"MUSINSA","clsDate":"20260101","orderNumber":"ORD-DUMMY-0004","orderOptionNumber":"OPT-DUMMY-04","internalProcessed":"Y","transmitResult":"Y","reasonCode":"003","remark":"","insertedAt":"20260101120000"}]
// 걸러진 행 브리지 — 액션 슬롯 인자(ctx.visible). 목록 검색을 거친 뒤 화면에 보이는 행(표가 여럿이면 마지막 표).
const visRef: { current: Record<string, unknown>[] } = { current: [] }
const REASONRADIO_OPTIONS_DEMO: Option[] = [{"value":"업무활용","label":"업무활용"},{"value":"고객요청","label":"고객요청"},{"value":"데이터 검증","label":"데이터 검증"},{"value":"기타","label":"기타"}]
// 확인 버튼 비활성 사유 툴팁(okDisabledTooltip) — 비활성일 때만 DS 툴팁으로 감싼다. extra = 푸터 좌측 보조 액션(footerExtra).
const withOkTip = (tip: string | null, extra?: ReactNode) => (_: ReactNode, { OkBtn, CancelBtn }: { OkBtn: FC; CancelBtn: FC }) => (
  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, alignItems: 'center' }}>
    {extra ? <div style={{ display: 'flex', gap: 8, marginRight: 'auto' }}>{extra}</div> : null}
    <CancelBtn />
    {tip ? (
      <core.Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{tip}</span>}>
        <span>
          <OkBtn />
        </span>
      </core.Tooltip>
    ) : (
      <OkBtn />
    )}
  </div>
)
// 선택 행 브리지 — 액션 슬롯 인자(ctx.selected). 같은 core.TableSelectionScope 안 표의 체크 선택 행(SelBridge 가 채운다). 한 화면에 스코프가 여럿이면 마지막으로 바뀐 스코프의 선택이다.
const selRef: { current: Record<string, unknown>[] } = { current: [] }
const selCtx = (): ActionCtx => ({ selected: selRef.current, visible: visRef.current })

const POPUP_DOWN = {
  bottomLeft: { points: ['tl', 'bl'], offset: [0, 4], overflow: { adjustX: true, adjustY: false } },
  bottomRight: { points: ['tr', 'br'], offset: [0, 4], overflow: { adjustX: true, adjustY: false } },
}

const filterFieldClass = (key: string): string => `pbo-ff--${key.replace(/[^A-Za-z0-9_-]/g, '_')}`
const FILTER_FOCUSABLE = 'input:not([type=hidden]):not([disabled]), textarea:not([disabled]), [contenteditable=true], button:not([disabled])'
const FILTER_OPEN_EVENTS = ['pointerdown', 'mousedown', 'mouseup', 'click'] as const
const openFilterField = (open: () => void, key: string) => {
  open()
  window.setTimeout(() => {
    const frame = document.querySelector(`.${filterFieldClass(key)}`)
    if (!frame) return
    frame.querySelector<HTMLElement>(FILTER_FOCUSABLE)?.focus()
    // 고른 항목을 바로 고칠 수 있게 목록·달력까지 펼친다 — antd 는 포커스만으로 열지 않는다(셀렉트=selector, 날짜=입력이 받는다).
    const host = frame.querySelector<HTMLElement>('.ant-select-selector') ?? frame.querySelector<HTMLElement>('.ant-picker input')
    if (!host) return
    // forEach — dev 레포 ESLint(no-restricted-syntax)가 for…of 를 막는다(2026-09-19 dry 실측).
    FILTER_OPEN_EVENTS.forEach((type) => host.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window })))
  }, 0)
}

const chipCodes = (v: unknown): string | null => (Array.isArray(v) && v.length ? `${(v as string[])[0]}${v.length > 1 ? ` 외 ${v.length - 1}개` : ''}` : null)

const chipSelect = (opts: Option[], v: unknown, required?: boolean): string | null =>
  v == null || v === '' ? (required ? '전체' : null) : (opts.find((o) => o.value === v)?.label ?? String(v as string | number))

const chipRange = (v: unknown, fmt = 'YY-MM-DD'): string | null => (Array.isArray(v) && v[0] && v[1] ? `${dayjs(String(v[0])).format(fmt)} ~ ${dayjs(String(v[1])).format(fmt)}` : null)

/** 기본 기간 프리셋 → ['YYYY-MM-DD','YYYY-MM-DD']. periodBase 'futureTo' = 오늘~+N(입고예정일 등) / 'pastTo' = -N~오늘. */
const presetRange = (preset?: string, periodBase: 'futureTo' | 'pastTo' = 'futureTo'): [string, string] | undefined => {
  if (!preset) return undefined
  const now = dayjs()
  const n = preset === 'today' ? [0, 'day'] : preset === 'week' ? [6, 'day'] : preset === 'month' ? [1, 'month'] : preset === 'month3' ? [3, 'month'] : preset === 'month6' ? [6, 'month'] : null
  if (!n) return undefined
  const other = periodBase === 'futureTo' ? now.add(n[0] as number, n[1] as 'day' | 'month') : now.subtract(n[0] as number, n[1] as 'day' | 'month')
  const [a, b] = periodBase === 'futureTo' ? [now, other] : [other, now]
  return [a.format('YYYY-MM-DD'), b.format('YYYY-MM-DD')]
}

const toDayjsPair = (v: unknown): [Dayjs, Dayjs] | null => (Array.isArray(v) && v[0] && v[1] ? [dayjs(String(v[0])), dayjs(String(v[1]))] : null)

/** 조회영역 필드 프레임(그룹 cmp.FilterField) — 접힘이면 값 칩(값 없으면 숨김), 열림이면 DS FormItem(라벨 위). 규격 = pbo-core filter-layout.css .pbo-filter-field */
function FilterField({ collapsed, label, required, tooltip, width, chip, fieldKey, onOpen, children }: { collapsed: boolean; label?: string; required?: boolean; tooltip?: string; width?: number | string; chip?: string | null; fieldKey?: string; onOpen?: () => void; children?: ReactNode }) {
  if (collapsed) {
    // 칩을 누르면 조회영역이 열리고 그 항목으로 포커스가 간다(전 화면 공통).
    const open = fieldKey && onOpen ? () => openFilterField(onOpen, fieldKey) : undefined
    return (
      <div
        className="pbo-filter-closed"
        hidden={chip == null}
        {...(open
          ? {
              role: 'button',
              tabIndex: 0,
              style: { cursor: 'pointer' }, // 규격 CSS 는 칩을 읽기 전용으로 본다 — 누를 수 있다는 표시만 여기서
              onClick: open,
              onKeyDown: (e: { key: string; preventDefault: () => void }) => {
                if (e.key !== 'Enter' && e.key !== ' ') return
                e.preventDefault()
                open()
              },
            }
          : {})}
      >
        {label ? (
          <div className="pbo-filter-chip-label">
            <label>{label}</label>
            {required ? <span className="pbo-filter-req">*</span> : null}
          </div>
        ) : null}
        <div className="pbo-filter-chip-value">{chip}</div>
      </div>
    )
  }
  return (
    <core.FormItem className={fieldKey ? `pbo-filter-field ${filterFieldClass(fieldKey)}` : 'pbo-filter-field'} label={label} required={required} tooltip={!!tooltip} tooltipText={tooltip} labelPosition="top" boxedItem={false} style={width != null ? { width } : undefined}>
      {children}
    </core.FormItem>
  )
}

/** 다건 코드 입력 — 인풋 + 우측 [+] 팝오버 textarea(Enter 로 다중 입력, 최대 `limit` — 기본 1,500). 규격 = .pbo-filter-code*
 *  구분자는 인풋·팝오버 모두 쉼표·공백·줄바꿈(1.0 코드 입력 동치 — 같은 문자열이 두 경로에서 다르게 해석되지 않게).
 *  한도는 자르지 않는다 — 초과분을 그대로 내보내 화면의 한도 경고가 살아 있게 한다(잘라 내면 앞 N개만 조용히 조회된다, moms-fe #739 Critical 2026-09-11). */
function MultiCodeInput({ value, onChange, placeholder, limit = 1500, disabled = false }: { value: string[]; onChange: (v: string[]) => void; placeholder?: string; limit?: number; disabled?: boolean }) {
  const [open, setOpen] = useState(false)
  // 편집 원문 두 벌(인풋=쉼표·팝오버=줄) — 밖으로 내는 배열만 정규화한다. 입력마다 정규화해 되돌려 쓰면 끝의 구분자가 즉시 지워진다.
  const [text, setText] = useState(value.join('\n'))
  const [line, setLine] = useState(value.join(', '))
  const wrapRef = useRef<HTMLDivElement>(null)
  const joined = value.join('\n')
  const normalize = (raw: string, splitBy: RegExp) => Array.from(new Set(raw.split(splitBy).map((s) => s.trim()).filter(Boolean)))
  const shown = normalize(text, /[\s,]+/)
  // 밖에서 값이 바뀌었을 때만(초기화·복원) 원문을 따라간다 — 내 입력이 만든 값이면 원문(끝의 구분자 포함)을 보존한다.
  const lastEmit = useRef(joined)
  useEffect(() => {
    if (joined === lastEmit.current) return
    lastEmit.current = joined
    setText(joined)
    setLine(value.join(', '))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [joined])
  const emit = (arr: string[]) => {
    lastEmit.current = arr.join('\n')
    onChange(arr)
  }
  const onLine = (raw: string) => {
    setLine(raw)
    const arr = normalize(raw, /[\s,]+/)
    setText(arr.join('\n'))
    emit(arr)
  }
  const onText = (raw: string) => {
    setText(raw)
    const arr = normalize(raw, /[\s,]+/)
    setLine(arr.join(', '))
    emit(arr)
  }
  useEffect(() => {
    if (!open) return
    const onDown = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false)
    }
    window.addEventListener('mousedown', onDown)
    return () => window.removeEventListener('mousedown', onDown)
  }, [open])
  return (
    <div className="pbo-filter-code" ref={wrapRef} style={{ position: 'relative', width: '100%' }}>
      <core.Input
        placeholder={placeholder ?? '다건 입력 시, 우측 + 버튼을 눌러주세요.'}
        value={line}
        disabled={disabled}
        onChange={(e) => onLine(e.target.value)}
        suffix={<PlusOutlined style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 14, cursor: disabled ? 'not-allowed' : 'pointer' }} onMouseDown={(e) => e.preventDefault()} onClick={(e) => { e.stopPropagation(); if (!disabled) setOpen(true) }} />}
      />
      {open && (
        <div className="pbo-filter-code-pop">
          <core.Input.TextArea
            value={text}
            placeholder="입력 후 Enter 키로 다중 입력이 가능합니다."
            onChange={(e) => onText(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && shown.length >= limit) e.preventDefault() }}
            autoSize={{ minRows: 4, maxRows: 16 }}
            autoFocus
          />
          <div className="pbo-filter-code-foot">
            <span style={{ fontSize: 12, color: shown.length > limit ? '#ff4d4f' : '#8c8c8c' }}>{shown.length} / {limit.toLocaleString()}</span>
            <core.Button size="small" onClick={() => onText('')}>
              초기화
            </core.Button>
          </div>
        </div>
      )}
    </div>
  )
}

/** 기간 필드 — [기간유형 셀렉트 120 고정] + 레인지피커(프리셋 태그·'오늘/최근 N개월' 푸터·maxRangeDays·periodBase·좁으면 MM-DD). 값 = ['YYYY-MM-DD','YYYY-MM-DD']. */
function DateRangeField({ value, onChange, defaultPeriod, periodBase = 'futureTo', maxRangeDays, hidePresets, typeOptions, typeValue, onTypeChange, format = 'YY-MM-DD' }: { value?: [string, string]; onChange: (v: [string, string] | undefined) => void; defaultPeriod?: string; periodBase?: 'futureTo' | 'pastTo'; maxRangeDays?: number; hidePresets?: boolean; typeOptions?: Option[]; typeValue?: string | number; onTypeChange?: (v: string | number) => void; format?: string }) {
  const TAG: Record<string, string> = { today: '오늘', week: '일주일', month: '1개월', month3: '3개월', month6: '6개월' }
  const def = presetRange(defaultPeriod, periodBase)
  // 값이 비면(진입·초기화) 기본 기간으로 되돌려 보고한다 — 조회 조건에도 기본 기간이 걸린다.
  useEffect(() => {
    if (!value && def) onChange(def)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])
  // 프리셋 태그는 **현재 값**에서 유도한다 — 조회영역을 접었다 펴면 이 컴포넌트가 리마운트되는데, 기본 프리셋으로 초기화하면
  //  실제 기간이 달라도 태그가 '오늘' 로 돌아간다(moms-fe #738 리뷰 2026-09-11). 값이 프리셋과 일치할 때만 태그를 단다.
  const tagOf = (v?: [string, string]): string | null => {
    if (!v) return (defaultPeriod && TAG[defaultPeriod]) ?? null
    const hit = Object.keys(TAG).find((k) => { const r = presetRange(k, periodBase); return !!r && r[0] === v[0] && r[1] === v[1] })
    return hit ? TAG[hit] : null
  }
  const [tag, setTag] = useState<string | null>(() => tagOf(value))
  const [selected, setSelected] = useState(0)
  const [open, setOpen] = useState(false)
  const [epoch, setEpoch] = useState(0)
  const [panel, setPanel] = useState<'date' | 'month' | 'year'>('date')
  const rootRef = useRef<HTMLDivElement>(null)
  const [compact, setCompact] = useState(false)
  useEffect(() => {
    const el = rootRef.current
    if (!el || !typeOptions?.length) return
    const ro = new ResizeObserver(() => setCompact(el.clientWidth > 0 && el.clientWidth < 260))
    ro.observe(el)
    return () => ro.disconnect()
  }, [typeOptions])
  const apply = (next: [Dayjs, Dayjs], label: string, months: number) => {
    onChange([next[0].format('YYYY-MM-DD'), next[1].format('YYYY-MM-DD')])
    setSelected(months)
    setTag(label)
    setOpen(false)
    setEpoch((e) => e + 1)
  }
  const picker = (
    <core.DatePicker.RangePicker placement="bottomLeft" {...({ builtinPlacements: POPUP_DOWN } as object)}
      key={`${epoch}-${compact ? 'c' : 'f'}`}
      className={typeOptions?.length ? 'pbo-filter-picker' : 'pbo-filter-picker pbo-filter-picker-full'}
      allowClear={false}
      format={compact ? 'MM-DD' : format}
      placeholder={['시작일', '종료일']}
      value={toDayjsPair(value ?? def)}
      open={open}
      onOpenChange={setOpen}
      onPanelChange={(_v, modes) => setPanel(((modes as string[]).find((x) => x !== 'date') as 'month' | 'year' | undefined) ?? 'date')}
      prefix={tag ? <core.Tag className="pbo-filter-date-tag" color="default" style={{ marginInlineEnd: 4 }}>{tag}</core.Tag> : undefined}
      onChange={(vals) => {
        setSelected(0)
        setTag(vals && vals[0] && vals[1] ? '직접' : null)
        onChange(vals && vals[0] && vals[1] ? [vals[0].format('YYYY-MM-DD'), vals[1].format('YYYY-MM-DD')] : undefined)
      }}
      disabledDate={(current, info) => {
        if (periodBase === 'pastTo' && current.isAfter(dayjs(), 'day')) return true
        if (maxRangeDays && info?.from && Math.abs(current.diff(info.from, 'days')) > maxRangeDays - 1) return true
        return false
      }}
      renderExtraFooter={
        hidePresets
          ? undefined
          : () => (
              <div className={`pbo-filter-date-footer ${panel}`}>
                <core.Button type="link" onClick={() => apply([dayjs(), dayjs()], '오늘', 0)}>
                  오늘
                </core.Button>
                <div className="pbo-filter-date-presets">
                  <span>{periodBase === 'pastTo' ? '최근' : '오늘부터'}</span>
                  {[1, 2, 3, 6].map((m) => (
                    <core.Button key={m} className={m === selected ? 'selected' : undefined} onClick={() => apply(periodBase === 'pastTo' ? [dayjs().subtract(m, 'month'), dayjs()] : [dayjs(), dayjs().add(m, 'month')], `${m}개월`, m)}>
                      {m}개월
                    </core.Button>
                  ))}
                </div>
              </div>
            )
      }
      style={{ width: '100%' }}
    />
  )
  if (!typeOptions?.length) return picker
  return (
    <div className="pbo-filter-date pbo-filter-row" ref={rootRef}>
      {/* 기준일 — onTypeChange 가 있으면(데모 typeFilterKey) 조회 조건에 싣는다. 없으면 종전대로 보이기만 한다. */}
      <core.Select placement="bottomLeft" builtinPlacements={POPUP_DOWN} className="pbo-filter-type" options={typeOptions} {...(onTypeChange ? { value: typeValue ?? typeOptions[0]?.value, onChange: onTypeChange } : { defaultValue: typeOptions[0]?.value })} popupMatchSelectWidth={false} />
      {picker}
    </div>
  )
}

/** 표 카운트 — 같은 core.TableSelectionScope 안 표의 선택 개수를 '선택 N / 전체' 로 함께 그린다(데모 TableStatRender 와 같은 규약). 스코프 밖이면 전체만. */
function SelStat(props: ComponentProps<typeof core.TableStat>) {
  const n = core.useTableSelectionCount()
  return <core.TableStat {...props} selectedCount={n && n > 0 ? n : undefined} />
}

/**
 * 선택 행 브리지(문서 50 슬롯 2차) — 같은 core.TableSelectionScope 안 표의 선택 행을 모듈 변수 selRef 로 흘려 보낸다.
 * 액션 슬롯이 ctx.selected 로 받고, 배선이 wiring.onSelect 로 같은 값을 구독한다(상세 표가 선택을 따라가는 화면).
 *
 * 한 화면에 스코프가 여럿이면(위아래 표) **선택이 있는 스코프만** selRef 를 쓴다 — 선택 표가 없는 스코프가
 * 빈 배열로 덮으면 다른 표의 선택이 사라진다(2026-09-19 gl11 위아래 표에서 발견).
 *
 * scope = 이 스코프를 연 그룹 노드 id. 선택을 **푼** 신호는 rows 가 빈 배열이라 행만 보고는 어느 표인지
 * 알 수 없다 — 배선이 위아래를 갈라 두려면 이 값이 있어야 한다(2026-09-21 est01).
 */
function SelBridge({ scope }: { scope: string }) {
  const s = core.useTableSelection()
  const rows = s?.rows
  const owned = useRef(false)
  useEffect(() => {
    if (rows?.length) {
      owned.current = true
      selRef.current = rows
      wiring.onSelect?.(rows, scope)
    } else if (owned.current) {
      owned.current = false
      selRef.current = []
      wiring.onSelect?.([], scope)
    }
    return () => { // 언마운트·스코프 이탈 때 비운다(모듈 변수라 다음 인스턴스로 새지 않게, #772 봇)
      if (!owned.current) return
      owned.current = false
      selRef.current = []
    }
  }, [rows, scope]) // scope 는 그룹 id 리터럴이라 실제로 안 바뀌지만 exhaustive-deps 규칙상 넣는다(moms-fe #787 봇)
  return null
}

// 표 슬롯 미지정 기본값 — 데모 목데이터를 그대로 그린다(wiring.rows 를 안 주거나 그 표만 비웠을 때).
const keepDemoRows = (demo: Row[]): Row[] => demo
export default function BizestCancelResultPage() {
  const hdrbcTitle_titleRowDef = usePageHeaderSticky()
  // 조회영역 값 버스(그룹 #bcFilterCard) — 각 필드가 filterKey(없으면 노드 id)를 키로 값을 올린다. [초기화]는 기본값으로 되돌리고 토큰을 올려
  //  모든 필드를 기본값으로 되돌린다(DS resetToken 계약). [조회]는 이 객체를 그대로 쿼리 조건으로 쓴다.
  const flBcFilterCardDefaults = useMemo(() => (wiring.filterDefaults?.bcFilterCard ?? ((d: Record<string, unknown>) => d))(flBcFilterCardDefaults_DEMO), []) // 조회 조건 기본값 — wiring.filterDefaults 슬롯(동기). [초기화] 가 돌아가는 값
  const flBcFilterCardDefaultsInitial = useMemo(() => (wiring.filterInitial?.bcFilterCard ?? ((d: Record<string, unknown>) => d))(flBcFilterCardDefaults), [flBcFilterCardDefaults]) // 진입 초기값 — wiring.filterInitial 슬롯(동기, 예: URL 복원). 없으면 기본값
  const [flBcFilterCard, setFlBcFilterCard] = useState<Record<string, unknown>>(flBcFilterCardDefaultsInitial)
  const [flBcFilterCardReset, setFlBcFilterCardReset] = useState(0)
  // 조회영역 접기(그룹 #bcFilterCard) — 닫히면 필드가 값 칩으로 바뀌고 [필터 열기] 로 되돌린다(규격 CSS .pbo-filter-collapse-*).
  const [flBcFilterCardCollapsed, setFlBcFilterCardCollapsed] = useState(false)
  const BCSHIPPER_OPTIONS = wiring.options?.BCSHIPPER_OPTIONS ? wiring.options.BCSHIPPER_OPTIONS(BCSHIPPER_OPTIONS_DEMO, flBcFilterCard) : BCSHIPPER_OPTIONS_DEMO // 옵션 — wiring.options 슬롯(두 번째 인자 = 현재 조회영역 값)
  const flBcFilterCardDisabled: Record<string, boolean> = wiring.filterDisabled?.bcFilterCard?.(flBcFilterCard) ?? {} // 칸 잠금 — wiring.filterDisabled 슬롯(인자 = 현재 조회영역 값)
  const BCOIFAPIFLAG_OPTIONS = wiring.options?.BCOIFAPIFLAG_OPTIONS ? wiring.options.BCOIFAPIFLAG_OPTIONS(BCOIFAPIFLAG_OPTIONS_DEMO, flBcFilterCard) : BCOIFAPIFLAG_OPTIONS_DEMO // 옵션 — wiring.options 슬롯(두 번째 인자 = 현재 조회영역 값)
  const BCRSNCODE_OPTIONS = wiring.options?.BCRSNCODE_OPTIONS ? wiring.options.BCRSNCODE_OPTIONS(BCRSNCODE_OPTIONS_DEMO, flBcFilterCard) : BCRSNCODE_OPTIONS_DEMO // 옵션 — wiring.options 슬롯(두 번째 인자 = 현재 조회영역 값)
  const [stSelEpoch, setStSelEpoch] = useState(0) // 토글 상태(스토어 키 'selEpoch')
  const selResetToken = wiring.selResetToken // 배선이 표를 새로 깔면 선택을 비운다(wiring.selResetToken)
  const selResetFirst = useRef(true)
  useEffect(() => { if (selResetFirst.current) { selResetFirst.current = false; return } setStSelEpoch((n) => n + 1) }, [selResetToken])
  useEffect(() => { // 옵션이 늦게 도착한 뒤 비어 있는 조회 조건을 채운다 — wiring.filterFallback 슬롯(값이 있는 키는 덮지 않는다)
    if (!wiring.filterFallback?.bcFilterCard) return
    setFlBcFilterCard((s) => { const patch = wiring.filterFallback?.bcFilterCard?.(s, { BCSHIPPER_OPTIONS, BCOIFAPIFLAG_OPTIONS, BCRSNCODE_OPTIONS }); if (!patch) return s; let n = s; Object.entries(patch).forEach(([k, v]) => { const c = s[k]; if (c === undefined || c === '' || (Array.isArray(c) && c.length === 0)) { if (n === s) n = { ...s }; n[k] = v } }); return n })
  }, [BCSHIPPER_OPTIONS, BCOIFAPIFLAG_OPTIONS, BCRSNCODE_OPTIONS, flBcFilterCardReset])
  // 페이저 ↔ 표 짝(pagerKey 'pager') — 액션바 페이저가 페이지를 소유하고 표는 그 페이지만 그린다. '몇 개씩' 미노출 = 10,000개씩(MOMS·MWMS 공통 규칙 2026-08-24).
  const [pgPager, setPgPager] = useState(() => ({ page: wiring.stateInitial?.pager?.pager?.page ?? 1, size: wiring.stateInitial?.pager?.pager?.size ?? 10000 })) // 진입 초기값 = wiring.stateInitial(예: URL 복원)
  const [stListq_table_q, setStListq_table_q] = useState(wiring.stateInitial?.listq?.["table.q"] ?? '') // 토글 상태(스토어 키 'listq:table.q')
  const [stModal_bcDownloadModal, setStModal_bcDownloadModal] = useState(false) // 토글 상태(스토어 키 'modal:bcDownloadModal')
  const ROWS_R = (wiring.rows?.ROWS ?? keepDemoRows)(ROWS_DEMO, { filters: flBcFilterCard, pager: pgPager }) // 표 데이터 — wiring.ts 슬롯(인자 = 데모 목데이터·조회 조건(모달 표는 모달 [조회] 적용 조건)·페이저)
  const ROWS = Array.isArray(ROWS_R) ? ROWS_R : ROWS_R.rows
  const ROWS_TOTAL = Array.isArray(ROWS_R) ? ROWS.length : (ROWS_R.total ?? ROWS.length)
  const COLUMNS_FN = wiring.columns?.bcTable // 컬럼 가공(플래그·열 추가) — wiring.columns 슬롯. 배치는 columnLayout
  const COLUMNS_W = useMemo(() => (COLUMNS_FN ? COLUMNS_FN(COLUMNS) : COLUMNS), [COLUMNS_FN])
  const ROWS_CL = wiring.columnLayout?.bcTable?.(COLUMNS_W) // 컬럼 배치(순서·너비·고정·숨김) — 없으면 표 내부 상태
  // [목록 검색] 표시 컬럼 전체 부분일치(대소문자 무시) — 어댑터 TableRender listQ 규약. 확정은 검색칸 엔터/돋보기(onSearch).
  const ROWSListed = useMemo(() => {
    const q = stListq_table_q.trim().toLowerCase()
    if (!q) return ROWS
    const idx = COLUMNS.map((c) => c.dataIndex).filter((d): d is string => typeof d === 'string')
    const hit = (x: Record<string, unknown>) => idx.some((di) => String((x[di] ?? '') as string | number).toLowerCase().includes(q))
    return ROWS.flatMap((r) => {
      const kids = Array.isArray(r.children) ? (r.children as Record<string, unknown>[]) : undefined
      if (kids) { const kept = kids.filter(hit); if (kept.length) return [{ ...r, children: kept }]; return hit(r) ? [{ ...r, children: [] }] : [] }
      return hit(r) ? [r] : []
    })
  }, [stListq_table_q, ROWS])
  visRef.current = ROWSListed // 액션 슬롯 ctx.visible — 목록 검색 뒤 보이는 행
  const ROWS_SERVERPAGED = !Array.isArray(ROWS_R) && ROWS_R.total != null // total 을 준 쪽이 서버 페이징
  const ROWS_PG = ROWS_SERVERPAGED ? pgPager.page : Math.min(pgPager.page, Math.max(1, Math.ceil(ROWSListed.length / pgPager.size))) // 건수가 줄어 지금 페이지가 범위를 넘으면 마지막 페이지를 그린다(옛 손코드 pageNo clamp — 목록 검색·업로드·삭제 뒤 빈 표 방지). 페이저 표시·onState 도 이 값(상태는 그대로 — 복원한 페이지를 로딩 중 0건으로 잃지 않는다)
  const ROWS_PAGE = ROWS_SERVERPAGED ? ROWSListed : ROWSListed.slice((ROWS_PG - 1) * pgPager.size, ROWS_PG * pgPager.size)
  const REASONRADIO_OPTIONS = wiring.options?.REASONRADIO_OPTIONS ? wiring.options.REASONRADIO_OPTIONS(REASONRADIO_OPTIONS_DEMO) : REASONRADIO_OPTIONS_DEMO // 옵션 — wiring.options 슬롯
  const [fs_bcDownloadModal, setFs_bcDownloadModal] = useState<FormState>({}) // 폼 버스 'bcDownloadModal' — 입력이 발행한 값
  const fsx_bcDownloadModal: FormState = wiring.form?.bcDownloadModal ? wiring.form.bcDownloadModal(fs_bcDownloadModal) : fs_bcDownloadModal // 유효 상태(wiring.form 이 파생 필드를 덮어쓴다)
  const fset_bcDownloadModal = (field: string, v: unknown) => setFs_bcDownloadModal((s) => ({ ...s, [field]: v }))
  useEffect(() => { // 열 때 폼 버스의 openResetFields 를 비운다(입력 DOM 은 destroyOnClose 로 새로 마운트)
    if (stModal_bcDownloadModal) setFs_bcDownloadModal((s) => { const n = { ...s }; ["reason","detail"].forEach((f) => { delete n[f] }); return n })
  }, [stModal_bcDownloadModal])
  useEffect(() => {
    document.body.classList.add('pbo-screen-portal')
    const hadFontsPortals = document.body.classList.contains('pbo-fonts-portals')
    if (!hadFontsPortals) document.body.classList.add('pbo-fonts-portals')
    return () => { document.body.classList.remove('pbo-screen-portal'); if (!hadFontsPortals) document.body.classList.remove('pbo-fonts-portals') }
  }, [])
  useEffect(() => { wiring.onState?.({ pager: { "pager": { ...pgPager, page: ROWS_PG } }, listq: { "table.q": stListq_table_q } }) }, [pgPager, ROWS_PG, stListq_table_q]) // 화면 상태 → 배선(URL/세션 persist)
  useEffect(() => { wiring.onModal?.({ "bcDownloadModal": stModal_bcDownloadModal }) }, [stModal_bcDownloadModal]) // 모달 열림 → 배선(후보 조회 게이트)
  return (
    <core.ConfigProvider theme={pboLogisticsTheme} renderEmpty={renderPboEmpty}>
      <div className="pbo-core-screen pbo-screen-shell pbo-fonts">
        {/* #bizestCancelPage BizestCancelResultPage */}
        <core.Flex vertical gap={16} align="stretch">
          {/* #workspaceTab WorkspaceTab */}
          <core.WorkspaceTab style={{ margin: "-24px -24px 0px -24px" }} activeLabel="출고취소(비제스트)" />
          {/* ▼ 그룹 cmp.TitleRow #bcTitle — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #bcTitle:titleRowDef TitleRow */}
          <core.Flex gap={8} justify="space-between" align="center" ref={hdrbcTitle_titleRowDef.ref} className={`dev-page-header-wrap pin${hdrbcTitle_titleRowDef.isSticky ? ' sticky' : ''}`} style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 'auto', minHeight: 40, top: 'calc(12px - var(--pbo-page-header-scroller-pad, 0px))', ['--pbo-page-header-bleed-top' as string]: '36px' }}>
            {/* #bcTitle:pageTitle PageTitle */}
            <core.Typography.Title level={4} style={{ margin: 0, whiteSpace: 'pre-line' }}>출고취소(비제스트)</core.Typography.Title>
            {/* #bcTitle:titleRight TitleRight */}
            <core.Flex gap={16} align="center">{null}</core.Flex>
          </core.Flex>
          {/* ▲ 그룹 cmp.TitleRow #bcTitle 끝 */}
          {/* ▼ 그룹 cmp.FilterCard #bcFilterCard — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #bcFilterCard:filterCardDef FilterCard */}
          <core.Card styles={{ body: { padding: "12px 20px" } }} style={{ border: '1px solid #d9d9d9', borderRadius: 8, minWidth: 0 }}>
            <div className="pbo-filter-collapse-open">
              {/* #bcFilterCard:filterBody FilterBody */}
              <div className={`${flBcFilterCardCollapsed ? 'pbo-filter-collapse-closed' : 'pbo-filter-collapse-open'}`}>
                {flBcFilterCardCollapsed && <span className="pbo-filter-empty-msg">필터가 적용된 항목이 없어요. 필터를 열어 원하는 조건으로 검색해 보세요.</span>}
                {/* #bcFilterCard:filterFields FilterFields */}
                <core.Flex gap={20} align="flex-start" wrap>
                  {/* ▼ 그룹 cmp.FilterField #bcShipper — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                  {/* #bcShipper:filterFieldDef FilterField */}
                  <FilterField collapsed={flBcFilterCardCollapsed} label="화주명" required={wiring.filterRequired?.["bcShipper:filterFieldDef"] ?? true} chip={chipSelect(BCSHIPPER_OPTIONS, flBcFilterCard.SPR_NM ?? undefined, true)} fieldKey="bcShipper:filterFieldDef" onOpen={() => setFlBcFilterCardCollapsed(false)}>
                    {/* #bcShipper:control Control */}
                    <core.Select disabled={flBcFilterCardDisabled.SPR_NM} placement="bottomLeft" builtinPlacements={POPUP_DOWN} className="pbo-filter-select" showSearch optionFilterProp="label" options={BCSHIPPER_OPTIONS} value={(flBcFilterCard.SPR_NM as string | undefined) ?? undefined} onChange={(v) => setFlBcFilterCard((s) => ({ ...s, SPR_NM: v }))} placeholder="화주명을(를) 선택해주세요." style={{ width: '100%' }} />
                  </FilterField>
                  {/* ▲ 그룹 cmp.FilterField #bcShipper 끝 */}
                  {/* ▼ 그룹 cmp.FilterField #bcClsDate — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                  {/* #bcClsDate:filterFieldDef FilterField */}
                  <FilterField collapsed={flBcFilterCardCollapsed} label="취소요청일자" required={wiring.filterRequired?.["bcClsDate:filterFieldDef"] ?? true} chip={chipRange(flBcFilterCard.CLS_DATE)} fieldKey="bcClsDate:filterFieldDef" onOpen={() => setFlBcFilterCardCollapsed(false)}>
                    {/* #bcClsDate:control Control */}
                    <DateRangeField key={flBcFilterCardReset} value={flBcFilterCard.CLS_DATE as [string, string] | undefined} onChange={(v) => setFlBcFilterCard((s) => ({ ...s, CLS_DATE: v }))} periodBase="pastTo" />
                  </FilterField>
                  {/* ▲ 그룹 cmp.FilterField #bcClsDate 끝 */}
                  {/* ▼ 그룹 cmp.FilterField #bcOrdNo — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                  {/* #bcOrdNo:filterFieldDef FilterField */}
                  <FilterField collapsed={flBcFilterCardCollapsed} label="주문번호" chip={chipCodes(flBcFilterCard.ORD_NO)} fieldKey="bcOrdNo:filterFieldDef" onOpen={() => setFlBcFilterCardCollapsed(false)}>
                    {/* #bcOrdNo:control Control */}
                    <MultiCodeInput value={(flBcFilterCard.ORD_NO as string[] | undefined) ?? []} onChange={(v) => setFlBcFilterCard((s) => ({ ...s, ORD_NO: v.length ? v : undefined }))} disabled={wiring.filterDisabled?.ORD_NO} />
                  </FilterField>
                  {/* ▲ 그룹 cmp.FilterField #bcOrdNo 끝 */}
                  {/* ▼ 그룹 cmp.FilterField #bcOrdOptNo — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                  {/* #bcOrdOptNo:filterFieldDef FilterField */}
                  <FilterField collapsed={flBcFilterCardCollapsed} label="주문일련번호" chip={chipCodes(flBcFilterCard.ORD_OPT_NO)} fieldKey="bcOrdOptNo:filterFieldDef" onOpen={() => setFlBcFilterCardCollapsed(false)}>
                    {/* #bcOrdOptNo:control Control */}
                    <MultiCodeInput value={(flBcFilterCard.ORD_OPT_NO as string[] | undefined) ?? []} onChange={(v) => setFlBcFilterCard((s) => ({ ...s, ORD_OPT_NO: v.length ? v : undefined }))} disabled={wiring.filterDisabled?.ORD_OPT_NO} />
                  </FilterField>
                  {/* ▲ 그룹 cmp.FilterField #bcOrdOptNo 끝 */}
                  {/* ▼ 그룹 cmp.FilterField #bcOifApiFlag — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                  {/* #bcOifApiFlag:filterFieldDef FilterField */}
                  <FilterField collapsed={flBcFilterCardCollapsed} label="전송처리결과" chip={chipSelect(BCOIFAPIFLAG_OPTIONS, flBcFilterCard.OIF_API_FLAG ?? '', false)} fieldKey="bcOifApiFlag:filterFieldDef" onOpen={() => setFlBcFilterCardCollapsed(false)}>
                    {/* #bcOifApiFlag:control Control */}
                    <core.Select disabled={flBcFilterCardDisabled.OIF_API_FLAG} placement="bottomLeft" builtinPlacements={POPUP_DOWN} className="pbo-filter-select" showSearch optionFilterProp="label" options={[{ value: '', label: '전체' }, ...BCOIFAPIFLAG_OPTIONS]} value={(flBcFilterCard.OIF_API_FLAG as string | undefined) ?? ''} onChange={(v) => setFlBcFilterCard((s) => ({ ...s, OIF_API_FLAG: v }))} placeholder="전체" style={{ width: '100%' }} />
                  </FilterField>
                  {/* ▲ 그룹 cmp.FilterField #bcOifApiFlag 끝 */}
                  {/* ▼ 그룹 cmp.FilterField #bcRsnCode — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                  {/* #bcRsnCode:filterFieldDef FilterField */}
                  <FilterField collapsed={flBcFilterCardCollapsed} label="사유코드" chip={chipSelect(BCRSNCODE_OPTIONS, flBcFilterCard.RSN_CODE ?? '', false)} fieldKey="bcRsnCode:filterFieldDef" onOpen={() => setFlBcFilterCardCollapsed(false)}>
                    {/* #bcRsnCode:control Control */}
                    <core.Select disabled={flBcFilterCardDisabled.RSN_CODE} placement="bottomLeft" builtinPlacements={POPUP_DOWN} className="pbo-filter-select" showSearch optionFilterProp="label" options={[{ value: '', label: '전체' }, ...BCRSNCODE_OPTIONS]} value={(flBcFilterCard.RSN_CODE as string | undefined) ?? ''} onChange={(v) => setFlBcFilterCard((s) => ({ ...s, RSN_CODE: v }))} placeholder="전체" style={{ width: '100%' }} />
                  </FilterField>
                  {/* ▲ 그룹 cmp.FilterField #bcRsnCode 끝 */}
                </core.Flex>
                {/* #bcFilterCard:filterFooter FilterFooter */}
                <core.Flex gap={8} justify="flex-end" align="center">
                  {/* #bcFilterCard:filterToggleButton FilterToggleButton */}
                  <core.Button icon={flBcFilterCardCollapsed ? <DownOutlined /> : <UpOutlined />} onClick={() => setFlBcFilterCardCollapsed((x) => !x)}>{`필터 ${flBcFilterCardCollapsed ? '열기' : '닫기'}`}</core.Button>
                  {/* #bcFilterCard:filterFooterDivider FilterFooterDivider */}
                  <span style={{ height: 18, margin: '0 0px', borderLeft: "1px solid #d9d9d9", display: 'block', flex: 'none' }} />
                  {/* #bcFilterCard:resetButton ResetButton */}
                  <core.Button onClick={() => { const go = () => { setFlBcFilterCard((wiring.filterDefaults?.bcFilterCard ?? ((d: Record<string, unknown>) => d))(flBcFilterCardDefaults_DEMO)); setFlBcFilterCardReset((t) => t + 1); wiring.onReset?.() }; const ok = wiring.canReset?.(); if (ok instanceof Promise) { ok.then((r) => { if (r !== false) go() }, () => undefined); return } if (ok !== false) go() }}>초기화</core.Button>
                  {/* #bcFilterCard:searchButton SearchButton */}
                  <core.Button type="primary" onClick={() => { Promise.resolve(wiring.actions?.search?.(flBcFilterCard)).then((r) => { if (r === false) { return } setPgPager((s) => (s.page === 1 ? s : { ...s, page: 1 })); setStSelEpoch((n) => n + 1); setStListq_table_q(''); }, reportActionError("search")) }}>조회</core.Button>
                </core.Flex>
              </div>
            </div>
          </core.Card>
          {/* ▲ 그룹 cmp.FilterCard #bcFilterCard 끝 */}
          {/* ▼ 그룹 cmp.TableGroup #tableGroup — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #tableGroup:tableGroupDef TableGroup */}
          <core.TableSelectionScope key={stSelEpoch}><SelBridge scope="tableGroup" />
            {/* #tableGroup:tableGroupInner TableGroupInner */}
            <core.Flex vertical gap={8} align="stretch">
              {wiring.feedback?.tableGroup}
              {/* #tableGroup:tableHeader TableHeader */}
              <core.Flex style={{ padding: "4px 0px 4px 0px" }} gap={8} justify="space-between" align="center" className="pbo-v2-actionbar-sticky">
                {/* #tableGroup:toolbarLeft ToolbarLeft */}
                <core.Space>
                  {/* #bcTableStat TableStat */}
                  <SelStat totalLabel={wiring.tableText?.tableGroup?.totalLabel} total={ROWS_TOTAL} />
                </core.Space>
                {/* #tableGroup:toolbarRight ToolbarRight */}
                <core.Space>
                  {/* #tableGroup:tablePager TablePager */}
                  <core.TablePager variant="paged" page={ROWS_PG} pageSize={pgPager.size} total={(stListq_table_q.trim() ? ROWSListed.length : ROWS_TOTAL)} showSizeChanger={false} onPage={(page, size) => { const go = () => { setStSelEpoch((n) => n + 1); setPgPager({ page: size === pgPager.size ? page : 1, size }) }; const ok = wiring.canChangePage?.({ pager: "pager", page, size }); if (ok instanceof Promise) { ok.then((r) => { if (r !== false) go() }, reportActionError("canChangePage")); return } if (ok !== false) go() }} />
                  {/* #tableGroup:listSearch ListSearch */}
                  <core.Input.Search placeholder="목록 검색" allowClear key={stSelEpoch} style={{ width: '100%', maxWidth: 240, minWidth: 240 }} defaultValue={stListq_table_q} onSearch={(v) => setStListq_table_q((v ?? '').trim())} />
                  {/* #tableGroup:toolbarDivider2 Divider */}
                  <span style={{ height: 18, margin: '0 4px', borderLeft: "1px solid #d9d9d9", display: 'block', flex: 'none' }} />
                  {/* #bcExcelButton ExcelButton */}
                  <core.Button icon={<DsIcon name="ic-download" size={16} color="currentColor" />} onClick={() => { if (wiring.opens?.bcExcelButton?.(selCtx()) === false) { return } setStModal_bcDownloadModal(true) }}>엑셀 다운로드</core.Button>
                </core.Space>
              </core.Flex>
              {/* #bcTable BizestCancelTable */}
              <core.Table columns={COLUMNS_W} dataSource={ROWS_PAGE} rowKey="rowKey" loading={Array.isArray(ROWS_R) ? undefined : ROWS_R.loading} locale={wiring.tableText?.tableGroup?.emptyText != null ? { emptyText: wiring.tableText?.tableGroup?.emptyText } : undefined} stickyOffset={104} size="middle" scroll={{ x: 'max-content' }} columnOrder={ROWS_CL?.columnOrder} onColumnOrderChange={ROWS_CL?.onColumnOrderChange} columnWidths={ROWS_CL?.columnWidths} onColumnWidthsChange={ROWS_CL?.onColumnWidthsChange} pinnedColumns={ROWS_CL?.pinnedColumns} onPinnedColumnsChange={ROWS_CL?.onPinnedColumnsChange} hiddenColumns={ROWS_CL?.hiddenColumns} onHiddenColumnsChange={ROWS_CL?.onHiddenColumnsChange} />
            </core.Flex>
          </core.TableSelectionScope>
          {/* ▲ 그룹 cmp.TableGroup #tableGroup 끝 */}
          {/* #bcDownloadModal DownloadModal */}
          <core.Modal destroyOnHidden /* openResetFields: reason, detail — 닫힐 때 버려 열 때 새 폼 */ open={stModal_bcDownloadModal} onCancel={() => { setStModal_bcDownloadModal(false) }} onOk={() => { Promise.resolve(wiring.actions?.bcDownloadModal_ok?.({ ...selCtx(), form: fsx_bcDownloadModal })).then((r) => { if (typeof r === 'string') core.message.success(r); setStModal_bcDownloadModal(false) }, (e: unknown) => { if ((e as { closeModal?: boolean } | null)?.closeModal) setStModal_bcDownloadModal(false) }) /* 실패 = 슬롯이 토스트·throw — 모달을 열어 둔다(던진 값에 closeModal: true 가 있으면 닫는다 — 옛 손코드가 닫고 나서 처리하던 실패). okClosesFirst 모달은 누르자마자 닫고 뒤에서 처리한다. onOk 타입은 () => void 라 async 를 직접 주지 않는다(#772 봇) */ }} okButtonProps={{ disabled: !(fsx_bcDownloadModal.reason && !!fsx_bcDownloadModal.detail && ((typeof fsx_bcDownloadModal.detail === 'string' ? fsx_bcDownloadModal.detail : '').trim() !== '' && (typeof fsx_bcDownloadModal.detail === 'string' ? fsx_bcDownloadModal.detail : '').trim().length >= 5)) }} footer={withOkTip(!(fsx_bcDownloadModal.reason && !!fsx_bcDownloadModal.detail && ((typeof fsx_bcDownloadModal.detail === 'string' ? fsx_bcDownloadModal.detail : '').trim() !== '' && (typeof fsx_bcDownloadModal.detail === 'string' ? fsx_bcDownloadModal.detail : '').trim().length >= 5)) ? "사유코드를 고르고 상세사유를 5글자 이상 입력해 주세요." : null)} title="엑셀 다운로드" width={520} okText="확인" cancelText="취소" className="pbo-screen-modal">
            {/* #bcDownloadModal-form ReasonForm */}
            <core.Form layout="horizontal" className="pbo-v2-form">
              {/* #bcDownloadModal-reason 사유코드Item */}
              <core.FormItem label="사유코드" required labelWidth={88}>
                {/* #bcDownloadModal-reasonRadio ReasonRadio */}
                <core.Radio.Group value={fsx_bcDownloadModal.reason} onChange={(e: { target: { value?: unknown } }) => fset_bcDownloadModal("reason", e.target.value)} options={REASONRADIO_OPTIONS} />
              </core.FormItem>
              {/* #bcDownloadModal-detail 상세사유Item */}
              <core.FormItem label="상세사유" required labelWidth={88}>
                {/* #bcDownloadModal-detailInput DetailInput */}
                <core.Input value={fsx_bcDownloadModal.detail == null ? '' : String(fsx_bcDownloadModal.detail as string | number)} onChange={(e: { target: { value?: unknown } }) => fset_bcDownloadModal("detail", e.target.value)} placeholder="사유를 입력하세요" style={{ width: "100%" }} />
                {/* #bcDownloadModal-detailHelp Help */}
                <core.Typography.Text style={{ fontSize: 12 }} type="secondary">5글자 이상 입력해주세요.</core.Typography.Text>
              </core.FormItem>
            </core.Form>
          </core.Modal>
        </core.Flex>
      </div>
    </core.ConfigProvider>
  )
}
